import { action, observable } from 'mobx';
import { SerializedData, AnalyticsStore } from 'bernie-core';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { BexApiStore, RequestOptions } from 'bernie-graphql';

import { FlightsShoppingPwaFlightSearchResultsFlightsSearch } from '__generated__/api/';
import analyticsWrapper from 'utility/analytics-wrapper';
import { clientInfoHeader } from 'utility/header-utils';

export class SearchResultsStore extends BexApiStore {
  @observable public isSubsequentialSearch: boolean;

  public hydrate(data: SerializedData): void {
    super.hydrate(data);

    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  public fetchLoading(
    searchVariables: FlightsShoppingPwaFlightSearchResultsFlightsSearch.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightSearchResultsFlightsSearch.FlightsSearch> {
    this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), this.bexApiSource.clientConfigs.bexApiUrl);

    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = clientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightSearchResultsLoadingFlightsSearch(searchVariables, options)
      .then(response => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), JSON.stringify(searchVariables));
        this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), JSON.stringify(response));
        const { flightsSearch } = response.data;

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsSearch
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'ENVERROR'), error);

        return null;
      });
  }

  public fetchResults(
    searchVariables: FlightsShoppingPwaFlightSearchResultsFlightsSearch.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightSearchResultsFlightsSearch.FlightsSearch> {
    this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), this.bexApiSource.clientConfigs.bexApiUrl);

    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = clientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightSearchResultsFlightsSearch(searchVariables, options)
      .then(response => {
        const { flightsSearch } = response.data;

        analyticsWrapper.setSearchResultsAnalytics(response);
        analyticsWrapper.publishSearchAnalyticsPayload(analytics);

        return {
          ...flightsSearch
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'ENVERROR'), error);

        return null;
      });
  }

  @action
  public setIsSubsequentialSearch = (isSubsequentialSearch?: boolean) => {
    this.isSubsequentialSearch = isSubsequentialSearch;
  };
}
